<p-progressSpinner class="w-100 text-center spinner_in_front_medium" *ngIf="spinner"></p-progressSpinner>
<div class="div_pin-container">
  <div *ngIf="pinConfirmationOption" class="d-flex flex-column align-items-center">
    <span class="d-block"><i class="pi pi-exclamation-circle delete_warning_pin"></i></span>
    <div class="delete_manager_pin">{{'PIN.MANAGER_PIN' | translate}}</div>
    <div class="delete_pin_description">{{'PIN.DELETE_USING_MANAGER_PIN' | translate}}</div>
  </div>
  <div class="login_field justify-content-center align-items-center">
    <label *ngIf="!pinConfirmationOption" class="lbl_pos_field text-center">{{'PIN.MANAGER_PIN_INFO'|translate}}
        <i *ngIf="errorModel!=null && errorModel['Pin']!=null"
        class="pi pi-exclamation-circle float-end me-1 error_color pt-1"
        pTooltip="{{errorModel['Password']|translate}}" tooltipPosition="top"></i>
    </label>
    <input #inputPin  type="password" class="input_pos_field" [(ngModel)]="loginModel.pin" style="caret-color: transparent;">

    <div class="div_pin d-flex flex-column mt-4">
        <div class="d-flex flex-row pin-buttons">
            <div *ngFor="let i of keypad1" (click)="addValue(i)">{{i}}</div>
        </div>
        <div class="d-flex flex-row pin-buttons">
            <div *ngFor="let i of keypad2" (click)="addValue(i)">{{i}}</div>
        </div>
        <div class="d-flex flex-row pin-buttons">
            <div *ngFor="let i of keypad3" (click)="addValue(i)">{{i}}</div>
        </div>
        <div class="d-flex flex-row pin-buttons">
            <div *ngFor="let i of keypad4" (click)="addValue(i)">
                <span *ngIf="i != 'errase'">{{i}}</span>
                <i *ngIf="i == 'errase'" class="pi c-icons c-icons-black pin-erase-icon">{{i}}</i>
            </div>
        </div>
    </div>
    <!-- <button class="unpair_btn mt-4" (click)="unpairDevice(loginModel)">Unpair</button> -->
</div>
</div>
